import {Routes} from '@angular/router'
import {
  adminAuthGuard,
  LoginComponent
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {ADMIN_MODULE, LOGIN_PATH} from './application/types'

export const routes: Routes = [
  {
    path: ADMIN_MODULE,
    loadChildren: () => import('./admin/admin.routes'),
    canActivate: [adminAuthGuard]
  },
  {
    path: LOGIN_PATH,
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
]
